export const __ThisModule__ = 'a-style';
export { ScopeModuleAStyle as ScopeModule } from './index.js';